import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;
  const isShowListPage = location.pathname.includes('showlist');

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = (
    <>
      <Link
        to="/"
        className={`transition-colors block ${
          isActive('/') ? 'text-red-600' : 'hover:text-red-600'
        }`}
        onClick={() => setMenuOpen(false)}
      >
        Home
      </Link>
      <Link
        to="/showlist"
        className={`transition-colors block ${
          isActive('/showlist') ? 'text-red-600' : 'hover:text-red-600'
        }`}
        onClick={() => setMenuOpen(false)}
      >
        Shows List
      </Link>
      <Link
        to="/links"
        className={`transition-colors block ${
          isActive('/links') ? 'text-red-600' : 'hover:text-red-600'
        }`}
        onClick={() => setMenuOpen(false)}
      >
        Links & Information
      </Link>
    </>
  );

  return (
    <header className="relative">
      {location.pathname === '/links' ? (
        <nav
          className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
            scrolled ? 'bg-black shadow-lg' : 'bg-transparent'
          }`}
        >
          <div className="container mx-auto px-4 py-4">
            <div className="flex justify-between items-center">
              <Link to="/" className="flex items-center space-x-2">
                <img
                  src="/logo_header.png"
                  alt="Logo"
                  className="w-[150px] h-auto"
                  style={{
                    filter: 'drop-shadow(0 0 10px rgba(255, 255, 255, 0.5))',
                  }}
                />
              </Link>

              <div className="hidden md:flex space-x-6 text-white text-base font-medium">
                {navLinks}
              </div>

              <div className="md:hidden">
                <button
                  onClick={() => setMenuOpen(!menuOpen)}
                  className="text-white focus:outline-none"
                >
                  <svg
                    className="w-6 h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d={
                        menuOpen
                          ? 'M6 18L18 6M6 6l12 12'
                          : 'M4 6h16M4 12h16M4 18h16'
                      }
                    />
                  </svg>
                </button>
              </div>
            </div>

            {/* Mobile Menu Dropdown */}
            {menuOpen && (
              <div className="md:hidden mt-4 space-y-4 text-white text-base font-medium">
                {navLinks}
              </div>
            )}
          </div>
        </nav>
      ) : (
        <div className="relative h-screen">
          <div
            className="absolute inset-0 bg-cover bg-center bg-no-repeat"
            style={{
              backgroundImage: "url('https://i.ibb.co/vxMzBxNB/B3.png')",
              backgroundAttachment: 'fixed',
            }}
          >
            <div className="absolute inset-0 bg-black bg-opacity-80" />
          </div>

          <nav
            className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
              scrolled ? 'bg-black shadow-lg' : 'bg-transparent'
            }`}
          >
            <div className="container mx-auto px-4 py-4">
              <div className="flex justify-between items-center">
                <Link to="/" className="flex items-center space-x-2">
                  <img
                    src="/logo_header.png"
                    alt="Logo"
                    className="w-[150px] h-auto"
                    style={{
                      filter: 'drop-shadow(0 0 10px rgba(255, 255, 255, 0.5))',
                    }}
                  />
                </Link>

                <div className="hidden md:flex space-x-6 text-white text-base font-medium">
                  {navLinks}
                </div>

                <div className="md:hidden">
                  <button
                    onClick={() => setMenuOpen(!menuOpen)}
                    className="text-white focus:outline-none"
                  >
                    <svg
                      className="w-6 h-6"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d={
                          menuOpen
                            ? 'M6 18L18 6M6 6l12 12'
                            : 'M4 6h16M4 12h16M4 18h16'
                        }
                      />
                    </svg>
                  </button>
                </div>
              </div>

              {/* Mobile Menu Dropdown */}
              {menuOpen && (
                <div className="md:hidden mt-4 space-y-4 text-white text-base font-medium">
                  {navLinks}
                </div>
              )}
            </div>
          </nav>

          <div className="absolute inset-0 flex flex-col items-center justify-center text-center p-4">
            <p
              className="text-gray-300 mb-8 max-w-2xl animate-fadeIn"
              style={{ fontSize: 50 }}
            >
              {isShowListPage ? 'Band Info' : 'UPCOMING SHOWS'}
            </p>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
